import React, { useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";

import axios from "axios";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { redirect, useNavigate } from "react-router-dom";
import InputLabel from "@mui/material/InputLabel";
import { MenuItem } from "@mui/material";

const Dashboard = () => {
  const [orderData, setOrderData] = useState([]);
  const [timePeriod, setTimePeriod] = useState("last_7_days");
  const [day, setDay] = useState([]);
  const navigation = useNavigate();
  const SuperAdmin = localStorage.getItem("is_superuser");

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    height: 115,
    borderRadius: 20,
  }));

  useEffect(() => {
    SuperAdmin === "true"
      ? axios
          .post(
            `https://app1.crazzyhub.com/api/admin/multivendor-dashboard-section-counter-data/`,
            { time_period: timePeriod },

            {
              headers: {
                Token: localStorage.getItem("Token"),
              },
            }
          )
          .then((response) => {
            setOrderData(response?.data?.data[0]);
            setDay(response?.data?.data[1]?.date);
          })
          .catch((error) => {
            console.log("error page", error.response);
            console.log(error, "dashboard counter Errror.....!");
          })
      : axios
          .post(
            `https://app1.crazzyhub.com/api/admin/multivendor-dashboard-section-counter-data-vendor/`,
            { time_period: timePeriod },
            {
              headers: {
                Token: localStorage.getItem("Token"),
              },
            }
          )
          .then((response) => {
            setOrderData(response?.data?.data[0]);
            console.log("dashboard count==>", response?.data?.data);
          })
          .catch((error) => {
            console.log("error page", error.response);
            console.log(error, "dashboard counter Errror.....!");
          });
  }, [timePeriod]);

  const handleChange = (event) => {
    setTimePeriod(event.target.value);
  };

  return (
    <>
      <div className="flex justify-between item-center w-[100%]">
        <div className="text-xl font-bold !text-gray-600 p-2">
          ALL ORDER STATUS
        </div>
        <div className="mt-2 mr-2">
          {/* <FormControl size="small">
              <Select
                className="!h-8 !w-44"
                value={timePeriod}
                onChange={(event) => setTimePeriod(event.target.value)}
              >
                <MenuItem size="small" className="text-sm" value="last_7_days">
                  LAST 7 DAYS
                </MenuItem>
                <MenuItem className="text-sm" value="today">
                  TODAY
                </MenuItem>
                <MenuItem className="text-sm" value="yesterday">
                  YESTERDAY
                </MenuItem>

                <MenuItem className="text-sm" value="last_15_days">
                  LAST 15 DAYS
                </MenuItem>
                <MenuItem className="text-sm" value="last_30_days">
                  LAST 30 DAYS
                </MenuItem>
              </Select>
            </FormControl> */}
          <FormControl sx={{ m: 1, minWidth: 200 }}>
            {/* <InputLabel id="demo-simple-select-autowidth-label">Age</InputLabel> */}
            <Select
              labelId="demo-simple-select-autowidth-label"
              id="demo-simple-select-autowidth"
              value={timePeriod}
              onChange={handleChange}
              autoWidth
              size="small"
              // className="w-full"
            >
              <MenuItem size="small" className="text-sm" value="last_7_days">
                LAST 7 DAYS
              </MenuItem>
              <MenuItem className="text-sm" value="today">
                TODAY
              </MenuItem>
              <MenuItem className="text-sm" value="yesterday">
                YESTERDAY
              </MenuItem>

              <MenuItem className="text-sm" value="last_15_days">
                LAST 15 DAYS
              </MenuItem>
              <MenuItem className="text-sm" value="last_30_days">
                LAST 30 DAYS
              </MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>
      <div className="m-2">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={1}>
            <Grid container item spacing={3}>
              <React.Fragment>
                <Grid item xs={3}>
                  <Item
                    className="p-3"
                    style={{
                      color: "#000000",
                      background: "linear-gradient(180deg, #FECED2, #FD8597)",
                    }}
                    onClick={() =>
                      navigation("/order-management", {
                        state: { status: "Pending" },
                      })
                    }
                  >
                    <div
                      className="float-left text-xl"
                      style={{ fontFamily: "  'Rye', cursive" }}
                    >
                      Pending
                    </div>
                    <br />
                    <div
                      className="mt-6 text-2xl text-white"
                      style={{ fontFamily: "  'Rye', cursive" }}
                    >
                      {orderData?.total_pending_sales_order}
                    </div>
                  </Item>
                </Grid>
                <Grid item xs={3}>
                  <Item
                    className="p-3"
                    style={{
                      color: "#000000",
                      background: "linear-gradient(180deg, #C7EBFE, #98B7FB)",
                    }}
                    onClick={() =>
                      navigation("/order-management", {
                        state: { status: "Pending" },
                      })
                    }
                  >
                    <div
                      className="float-left text-xl"
                      style={{ fontFamily: "  'Rye', cursive" }}
                    >
                      Shipped
                    </div>
                    <br />
                    <div
                      className="mt-6 text-2xl text-white"
                      style={{ fontFamily: "  'Rye', cursive" }}
                    >
                      {orderData?.total_shipped_sales_order}
                    </div>
                  </Item>
                </Grid>
                <Grid item xs={3}>
                  <Item
                    className="p-3"
                    style={{
                      color: "#000000",
                      background: "linear-gradient(180deg, #CEFAE7, #78ECAA)",
                    }}
                    onClick={() =>
                      navigation("/order-management", {
                        state: { status: "Delivered" },
                      })
                    }
                  >
                    <div
                      className="float-left text-xl"
                      style={{ fontFamily: "  'Rye', cursive" }}
                    >
                      Delivered
                    </div>
                    <br />
                    <div
                      className="mt-6 text-2xl text-white"
                      style={{ fontFamily: "  'Rye', cursive" }}
                    >
                      {orderData?.total_delivered_sales_order}
                    </div>
                  </Item>
                </Grid>
                <Grid item xs={3}>
                  <Item
                    className="p-3"
                    style={{
                      color: "#000000",
                      background: "linear-gradient(180deg, #FEE2FE, #C79AFF)",
                    }}
                  >
                    <div
                      className="float-left text-xl"
                      style={{ fontFamily: "  'Rye', cursive" }}
                    >
                      Accepted
                    </div>
                    <br />
                    <div
                      className="mt-6 text-2xl text-white"
                      style={{ fontFamily: "  'Rye', cursive" }}
                    >
                      {orderData?.total_accepted_sales_order}
                    </div>
                  </Item>
                </Grid>
              </React.Fragment>
            </Grid>
            <Grid container item spacing={3}>
              <React.Fragment>
                <Grid item xs={3}>
                  <Item
                    className="p-3"
                    style={{
                      color: "#000000",
                      background: "linear-gradient(180deg, #FEF9C3, #F5F531)",
                    }}
                    onClick={() =>
                      navigation("/order-management", {
                        state: { status: "Assigned" },
                      })
                    }
                  >
                    <div
                      className="float-left text-xl"
                      style={{ fontFamily: "  'Rye', cursive" }}
                    >
                      Assigned
                    </div>
                    <br />
                    <div
                      className="mt-6 text-2xl text-white"
                      style={{ fontFamily: "  'Rye', cursive" }}
                    >
                      {orderData?.total_assigned_sales_order}
                    </div>
                  </Item>
                </Grid>
                <Grid item xs={3}>
                  <Item
                    className="p-3"
                    style={{
                      color: "#000000",
                      background: "linear-gradient(180deg, #F0ABFC, #8A42A8)",
                    }}
                    onClick={() =>
                      navigation("/order-management", {
                        state: { status: "Cancelled" },
                      })
                    }
                  >
                    <div
                      className="float-left text-xl"
                      style={{ fontFamily: "  'Rye', cursive" }}
                    >
                      Cancelled
                    </div>
                    <br />
                    <div
                      className="mt-6 text-2xl text-white"
                      style={{ fontFamily: "  'Rye', cursive" }}
                    >
                      {orderData?.total_canceled_sales_order}
                    </div>
                  </Item>
                </Grid>
                <Grid item xs={3}>
                  <Item
                    className="p-3"
                    style={{
                      color: "#000000",
                      background: "linear-gradient(180deg, #9FC39B, #648606)",
                    }}
                    onClick={() =>
                      navigation("/order-management", {
                        state: { status: "Returned" },
                      })
                    }
                  >
                    <div
                      className="float-left text-xl"
                      style={{ fontFamily: "  'Rye', cursive" }}
                    >
                      Returned
                    </div>
                    <br />
                    <div
                      className="mt-6 text-2xl text-white"
                      style={{ fontFamily: "  'Rye', cursive" }}
                    >
                      {orderData?.total_returned_sales_order}
                    </div>
                  </Item>
                </Grid>
                <Grid item xs={3}>
                  <Item
                    className="p-3"
                    style={{
                      color: "#000000",
                      background: "linear-gradient(180deg, #BFDBFE, #6351FE)",
                    }}
                    onClick={() =>
                      navigation("/order-management", {
                        state: { status: "Refunded" },
                      })
                    }
                  >
                    <div
                      className="float-left text-xl"
                      style={{ fontFamily: "  'Rye', cursive" }}
                    >
                      Refunded
                    </div>
                    <br />
                    <div
                      className="mt-6 text-2xl text-white"
                      style={{ fontFamily: "  'Rye', cursive" }}
                    >
                      {orderData?.total_refunded_sales_order}
                    </div>
                  </Item>
                </Grid>
              </React.Fragment>
            </Grid>
            <Grid container item spacing={3}>
              <React.Fragment>
                <Grid item xs={3}>
                  <Item
                    className="p-3"
                    style={{
                      color: "#000000",
                      background: "linear-gradient(180deg, #FECACA, #E04A3A)",
                    }}
                    onClick={() =>
                      navigation("/order-management", {
                        state: { status: "Drafts" },
                      })
                    }
                  >
                    <div
                      className="float-left text-xl"
                      style={{ fontFamily: "  'Rye', cursive" }}
                    >
                      Drafts
                    </div>
                    <br />
                    <div
                      className="mt-6 text-2xl text-white"
                      style={{ fontFamily: "  'Rye', cursive" }}
                    >
                      {orderData?.total_drafts_sales_order}
                    </div>
                  </Item>
                </Grid>
                <Grid item xs={3}>
                  <Item
                    className="p-3"
                    style={{
                      color: "#000000",
                      background: "linear-gradient(180deg, #BDBDBD, #828A91)",
                    }}
                    onClick={() =>
                      navigation("/order-management", {
                        state: { status: "Rejected" },
                      })
                    }
                  >
                    <div
                      className="float-left text-xl"
                      style={{ fontFamily: "  'Rye', cursive" }}
                    >
                      Rejected
                    </div>
                    <br />
                    <div
                      className="mt-6 text-2xl text-white"
                      style={{ fontFamily: "  'Rye', cursive" }}
                    >
                      {orderData?.total_rejected_sales_order}
                    </div>
                  </Item>
                </Grid>
                <Grid item xs={3}>
                  <Item
                    className="p-3"
                    style={{
                      color: "#000000",
                      background: "linear-gradient(180deg, #80C384, #12AA9E)",
                    }}
                    onClick={() =>
                      navigation("/add-product-variant", {
                        state: {
                          startDay:
                            day.length == 1 ? "" : day.slice(-1).toString(),
                          endDay: day[0],
                        },
                      })
                    }
                  >
                    <div
                      className="float-left text-xl"
                      style={{ fontFamily: "  'Rye', cursive" }}
                    >
                      In Stock
                    </div>
                    <br />
                    <div
                      className="mt-6 text-2xl text-white"
                      style={{ fontFamily: "  'Rye', cursive" }}
                    >
                      {orderData?.in_stock_count}
                    </div>
                  </Item>
                </Grid>
              </React.Fragment>
            </Grid>
          </Grid>
        </Box>
      </div>
    </>
  );
};

export default Dashboard;
